import { z } from 'zod';

export const organisationDtoSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: z.string(),
  // type: z.enum(OrganisationTypes), // we could be strict and refuse if type value is not is our list
  activity: z.string().nullable(),
  logo: z.string().nullable(),
  location: z.string().nullable(),
  userId: z.string(),
  address: z.string().nullable(),
  zipCode: z.string().nullable(),
  country: z.string().nullable(),
  website: z.string().nullable(),
  deleted: z.boolean(),
});

export const getOrganisationDtoSchema = z.union([
  organisationDtoSchema,
  z.object({
    data: z.array(organisationDtoSchema),
    limit: z.number(),
    skip: z.number(),
    total: z.number(),
  }),
]);

export type OrganisationDto = z.infer<typeof organisationDtoSchema>;
